import formGeraSenha from './assets/modules/formGeraSenha';
import './assets/modelo.css';

formGeraSenha();